import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import store from 'store';

import { ROLE, checkRole } from '@common/components/RBAC';

import ChangePasswordModal from '../Modal';
import ResetPasswordModal from '../Modal/ResetPasswordModal';
import StyledProfileChangePasswordButton from './style';

function ChangePassword() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const isDemoUser = checkRole(ROLE.DEMO_TIS);

	const handleModalOpen = (value: boolean) => () => {
		setIsModalOpen(value);
	};

	const { t } = useTranslation();

	return (
		<>
			<StyledProfileChangePasswordButton
				onClick={handleModalOpen(true)}
				variant="contained"
				color="primary"
				disabled={store.auth.isMentorView}
			>
				<Typography variant="subtitle2">
					{isDemoUser ? t('profile.resetPassword') : t('profile.changePassword')}
				</Typography>
			</StyledProfileChangePasswordButton>
			{isDemoUser ? (
				<ResetPasswordModal open={isModalOpen} onClose={handleModalOpen(false)} />
			) : (
				<ChangePasswordModal open={isModalOpen} onClose={handleModalOpen(false)} />
			)}
		</>
	);
}

export default observer(ChangePassword);
